import React from 'react'
import classnames from 'classnames'

const CircleColor = ({onClick, bgUrl, color, className, size, style}) => {
    return (
        <span
            onClick={onClick}
            className={classnames('CircleColor', className)}
            style={{
                '--color': color,
                '--size': size,
                '--image': `url(${bgUrl})`,
                ...style,
            }}
        ></span>
    )
}

export default CircleColor
